module.exports = __webpack_public_path__ + "static/media/notosans-light.91a759d6.woff2";